import React, { useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import {
  SectionHeading,
  Subheading as SubheadingBase,
} from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import EmailIllustrationSrc from "images/contact_new.png";
import { serverUtilities } from "../../services/serverutilities.service";
import ContactUsForm from "components/forms/SimpleContactUs.js";

const Container = tw.section`
  bg-[#01325b] py-16
`;

const TwoColumn = tw.div`
  max-w-6xl mx-auto px-6 flex flex-col md:flex-row gap-12
`;

const Column = tw.div`
  w-full
`;

const FormColumn = tw(Column)`
  md:w-1/2
`;

const TextColumn = tw(Column)`
  md:w-1/2 text-white flex flex-col justify-center
`;

const Heading = tw.h1`
  text-3xl md:text-4xl font-bold mb-4 text-white
`;

const Description = tw.p`
  text-gray-200 text-lg leading-relaxed
`;

//const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`
const SubmitButton = tw.button`w-full sm:w-64 mt-6 py-3 bg-brand-300 text-white rounded font-bold tracking-wide text-sm transition duration-300 transform focus:outline-none focus:shadow-outline hover:bg-brand-100 hover:text-white hocus:-translate-y-px`;

export default ({
  subheading = "Contact Us",

  wappAllow = true,
  formActionUrl = "",
  heading = (
    <>
      <span tw="text-yellow-500">Get in Touch</span>
      <wbr /> Now.
    </>
  ),
  description = (
    <>
      Drop in at Our Office at{" "}
      <b>
        U-110, Ground Floor, Vikas Marg, Near Laxmi Nagar Metro Station,
        Shakarpur, Delhi – 110092
      </b>{" "}
      or Fill out this form to start a conversation with a Young Minds Team
      Member about your Content Delivery and get your questions answered.
    </>
  ),
  submitButtonText = "Submit",
  formAction = "#",
  formMethod = "get",
  textOnLeft = true,
  fromPage = "",
}) => {
  // The textOnLeft boolean prop can be used to display either the text on left or right side of the image.
  let fields = {};
  const [msgVal, setError] = useState("");
  const [isDisable, setDisable] = useState("0");
  const handleChange = (e) => {
    //////console.log(e.target.name);
    fields[e.target.name] = e.target.value;
  };
  const sendLogin = (e) => {
    //////console.log(fields);
    //alert ("1");
    //////console.log("I am clicked");
    //e.preventDefault();
    fields["fname"] = document.getElementById("fname-input").value;
    fields["phone"] = document.getElementById("phone-input").value;
    fields["email"] = document.getElementById("email-input").value;
    fields["message"] = document.getElementById("message-input").value;
    fields["refUrl"] = window.location.href;
    //e.preventDefault();
    //////console.log(validateForm());
    if (validateForm()) {
      //////console.log("valid true");
      serverUtilities
        .addlead(
          fromPage,
          fields.fname,
          fields.lname,
          fields.email,
          fields.phone,
          fields.message,
          fields.refUrl
        )
        .then((leadData) => {
          //////console.log(leadData);
          if (leadData.status == "0") {
            setError(leadData.message);
            setDisable(leadData.status);
          } else {
            setError(leadData.message);
            setDisable(leadData.status);
          }
        });
    }
  };
  function validateForm() {
    let formIsValid;
    setError("");
    const Emailregex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,3})$/i;
    if (fields.fname == "") {
      setError("*Please Enter Your Name");
      document.getElementById("fname-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    // if(fields.fname != null){
    //   if (fields.fname.match(/^[a-zA-Z]+$/)) {
    //     setError("*Please type only letters");
    //     document.getElementById('fname-input').focus();
    //   }
    // }
    if (fields.fname.length != "") {
      if (fields.fname.length < 3) {
        setError("*Please Enter Your Name between 4 to 8 characters");
        document.getElementById("fname-input").focus();
        formIsValid = false;
        return formIsValid;
      }
    }
    // if(fields.lname == ''){
    //   setError("*Please Enter Your Last Name");
    //   document.getElementById('lname-input').focus();
    //   formIsValid = false;
    //   return formIsValid;
    // }
    // if(fields.lname.length != ''){
    //   if(fields.lname.length < 3){
    //     setError("*Please Enter Your Last Name between 4 to 8 characters");
    //     document.getElementById('lname-input').focus();
    //     formIsValid = false;
    //     return formIsValid;
    //   }
    //  }

    if (fields.email == "") {
      setError("*Please Enter Your Email");
      document.getElementById("email-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    if (fields.email != "" && Emailregex.test(fields.email) === false) {
      setError("Please Enter Valid Email");
      document.getElementById("email-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    if (fields.phone == "") {
      setError("*Please Enter Your Phone Number");
      document.getElementById("phone-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    if (fields.phone.length < 8) {
      setError("*Incorrect Phone Number. Use ISD code with number");
      document.getElementById("phone-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    if (fields.message == "") {
      setError("*Please Enter Your Message");
      document.getElementById("message-input").focus();
      formIsValid = false;
      return formIsValid;
    }
    return (formIsValid = true);
  }
  return (
    <Container>
      <TwoColumn>
        {/* LEFT – CONTACT FORM */}
        <FormColumn>
          <ContactUsForm
            fromPage={fromPage}
            wapp={wappAllow}
            formActionUrl={formActionUrl}
          />
          <p tw="text-red-400 mt-4">{msgVal}</p>
        </FormColumn>

        {/* RIGHT – TEXT */}
        <TextColumn>
          <Heading>{heading}</Heading>
          <Description>{description}</Description>
        </TextColumn>
      </TwoColumn>
    </Container>
  );
};
